/*
 * Promo code banner: copies the discount code to the clipboard on click and shows brief
 * "copied" feedback. Loaded as an external, deferred script from the theme layouts so it
 * keeps working across the theme's instant navigation.
 */
(function () {
  if (customElements.get('promo-code-banner')) return;

  customElements.define('promo-code-banner', class extends HTMLElement {
    connectedCallback() {
      this.code = this.getAttribute('data-code') || '';
      this.copiedLabel = this.getAttribute('data-copied-label') || 'Kopiert!';
      this.button = this.querySelector('[data-promo-copy]');
      this.valueEl = this.querySelector('.promo-banner__code-value');

      if (this.button) {
        this.button.addEventListener('click', () => this.copy());
      }
    }

    copy() {
      var self = this;
      var text = this.code;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(
          function () { self.showCopied(); },
          function () { self.fallbackCopy(text); }
        );
      } else {
        this.fallbackCopy(text);
      }
    }

    fallbackCopy(text) {
      try {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      } catch (error) {
        /* ignore */
      }
      this.showCopied();
    }

    showCopied() {
      if (!this.button || !this.valueEl) return;

      if (this._timer) clearTimeout(this._timer);
      if (this._original == null) this._original = this.valueEl.textContent;

      this.valueEl.textContent = this.copiedLabel;
      this.button.classList.add('is-copied');

      var self = this;
      this._timer = setTimeout(function () {
        self.valueEl.textContent = self._original;
        self.button.classList.remove('is-copied');
      }, 1600);
    }
  });
})();
